export const stats = [
  { value: '+400', label: "Unità e Fichè Pronte all'Uso" },
  { value: '+1.200', label: 'Docenti Soddisfatti' },
  { value: '3.500+', label: 'Ore Risparmiate' },
  { value: '98%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+400', label: 'Unità e Attività (1ª Primaria a 3ª Media)' },
  { value: '8', label: 'Volumi Digitali Completi (PDF)' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a cercare mappe e dati aggiornati su 10 siti diversi',
  'Lezioni confuse perché mancano supporti visivi chiari per spiegare i confini o il clima',
  "Nessuna connessione reale tra il libro di testo e l'attualità del mondo",
  'Difficoltà nel creare verifiche inclusive (BES/DSA) senza lavorare di notte',
  'Studenti demotivati che pensano che "la geografia sia solo una lista di nomi"',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per entrare in classe con sicurezza',
  "Mappe visuali e moderne che catturano l'attenzione al primo sguardo",
  'Infografiche e mappe concettuali integrate in ogni singola unità',
  'Quiz, verifiche, soluzioni e rubriche già pronti al 100%',
  'Studenti che viaggiano con la mente, capiscono il mondo e si sentono cittadini globali',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Ansia da spiegazione: arrivare in classe senza sapere come rendere semplice un concetto complesso (come la tettonica o la geopolitica)',
  },
  {
    emoji: '⏱️',
    text: "Domeniche rubate: passare l'intera domenica a preparare materiali che dovrebbero essere già pronti",
  },
  {
    emoji: '🤷',
    text: 'Caos creativo: faticare a trovare schede didattiche che siano davvero di alta qualità, visive e aggiornate',
  },
  {
    emoji: '📋',
    text: 'Valutazione infinita: nessuna rubrica di valutazione chiara o test allineato con il programma ministeriale',
  },
  {
    emoji: '😴',
    text: 'Studenti persi: alunni che restano indietro perché il materiale non è inclusivo o è troppo testuale (BES/DSA)',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '8 Volumi PDF basati sull\u2019Anno Scolastico (1ª Primaria – 3ª Media)',
    text: 'Un curriculum completo: dalla scoperta dello spazio vicino alla sostenibilità globale',
  },
  {
    emoji: '🗺️',
    title: 'Kit Mappe ed Esercitazioni Visive',
    text: 'Cartine fisiche, politiche e tematiche ad alta risoluzione pronte da stampare o proiettare',
  },
  {
    emoji: '✏️',
    title: 'Script delle Lezioni «Pronti al Volo»',
    text: 'Suggerimenti didattici inclusi nel Bono #1 che ti dicono esattamente come condurre la lezione',
  },
  {
    emoji: '📐',
    title: 'Geografia Visuale: Infografiche e Schemi',
    text: 'Grafiche moderne che rendono comprensibili i processi: cicli naturali, migrazioni, economia',
  },
  {
    emoji: '📊',
    title: 'Verifiche, Soluzioni e BES/DSA',
    text: 'Strumenti di valutazione completi e versioni facilitate per una didattica davvero inclusiva (Bono #4)',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Chiavi di Correzione)',
    text: 'Soluzioni complete di ogni esercizio per correzioni istantanee e senza stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/r9k43ozbPd5Kg4KuyA9Zvm/Captura-de-pantalla-2026-09-04-a-la_s_-9.53.40_p._m..webp',
    level: '1ª Primaria · Attività',
    title: 'Classifica gli Elementi: Naturale o Artificiale?',
    caption:
      'Scheda pronta da stampare: un paesaggio illustrato da osservare, con legenda a colori, conteggio degli elementi e spazio per nome e data.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pu5ToKvAxz3g7XMU5RLyNw/Captura-de-pantalla-2026-09-04-a-la_s_-10.13.55_p._m..webp',
    level: '2ª Primaria · Attività',
    title: 'La Vita Marina — Gli Animali del Mare',
    caption:
      'Tavola illustrata con pesci, molluschi, crostacei, rettili e mammiferi già etichettati, più cinque domande e uno spazio per il disegno.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7dSTwZr8bGCnhFXMVMVqzd/Captura-de-pantalla-2026-09-04-a-la_s_-10.14.41_p._m..webp',
    level: '3ª Primaria · Attività',
    title: 'Il Nord-Est — Regioni e Capoluoghi',
    caption:
      'Cartina illustrata con regioni, capoluoghi e simboli locali, istruzioni chiare, domande a scelta multipla, curiosità e cartina muta da colorare.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jQPDQyxfAb6vcPVoZd2SDk/Captura-de-pantalla-2026-09-04-a-la_s_-10.16.59_p._m._(1)_(1).webp',
    level: '4ª Primaria · Attività',
    title: 'Centro-Est Europa — Paesi e Capitali',
    caption:
      'Mappa politica con paesi, capitali e il corso del Danubio, cinque quesiti a risposta multipla e un box curiosità.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bSt8gYD4k6jjvXzNtDXYfC/Captura_de_pantalla_2026-09-04_a_la(s)_10.17.37_p.webp',
    level: '5ª Primaria · Attività',
    title: 'I 5 Continenti — Dove Siamo?',
    caption:
      'Planisfero a colori con continenti e oceani, quattro domande a scelta multipla, cartina muta da colorare e definizione di «continente».',
  },
]

export const bonuses = [
  {
    title: 'Metodo 5 Minuti: Guida Rapida',
    was: '€19',
    text: 'Trasforma ogni volume in una lezione immediata. Mai più ansia da preparazione',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/9057db8b-da86-4f2f-9513-0a844abff374.jpg',
  },
  {
    title: 'Agenda del Docente Geografo',
    was: '€27',
    text: "Planner settimanale pronto per organizzare l'intero anno senza stress",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1b0a2f4c-cf67-465f-a136-20b2c1c8a2ef.jpg',
  },
  {
    title: 'Kit Classe Senza Caos',
    was: '€36',
    text: 'Checklist tecniche per stampa, LIM e materiali. Tutto fluido, nessun intoppo',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/5cd04c9a-8b8f-4123-90e2-370f22c779ff.jpg',
  },
  {
    title: 'Pronto Recupero: 20 Micro-Schede',
    was: '€17',
    text: 'Materiale specifico per chi resta indietro (BES/DSA). Nessuno è escluso',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b75f55f3-2f6e-4530-ba5e-5682227b1a1e.jpg',
  },
  {
    title: 'Diario del Piccolo Geografo',
    was: '€17',
    text: 'Quaderno di missioni per motivare gli studenti e certificare i loro progressi',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4d2e8239-19f9-47a2-905e-e8e895d10ee3.jpg',
  },
]

export const offerRows = [
  { label: 'GEOGRAFIA PRONTA™ (8 Volumi Digitali PDF)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€116' },
]

export const testimonials = [
  {
    quote:
      'Finalmente mappe chiare e lezioni che i ragazzi seguono con interesse. Ho recuperato i miei weekend!',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      "Il Diario del Piccolo Geografo ha cambiato l'atteggiamento della mia classe. Sono tutti motivatissimi.",
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
  {
    quote:
      'Le schede di recupero sono fondamentali per i miei alunni DSA. Un acquisto obbligatorio.',
    name: 'Luca B.',
    location: 'Roma 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente via email in formato PDF dopo il pagamento.',
  },
  {
    q: 'Funziona per le medie?',
    a: 'Sì, i volumi 6, 7 e 8 sono specifici per la Secondaria di Primo Grado.',
  },
  {
    q: 'È adatto per alunni BES/DSA?',
    a: 'Assolutamente sì, grazie al design visuale e al Bonus #4 incluso.',
  },
  {
    q: 'Ci sono costi mensili?',
    a: 'No. Paghi una volta e il materiale è tuo per sempre.',
  },
]
